import React from 'react';
import { Button } from '@/components/ui/button';
import { Printer, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FisaClient = () => {
  const navigate = useNavigate();

  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      {/* Header - hidden when printing */}
      <div className="print:hidden bg-purple-900 p-4 flex items-center justify-between">
        <Button 
          onClick={() => navigate('/magneticTransformation')} 
          variant="outline" 
          className="border-white/30 text-white hover:bg-white/10"
        >
          <ArrowLeft className="h-4 w-4 mr-2" /> Înapoi
        </Button>
        <h1 className="text-white text-xl font-bold">Fișa Clientului - Printabilă</h1>
        <Button onClick={handlePrint} className="bg-green-500 hover:bg-green-600">
          <Printer className="h-4 w-4 mr-2" /> Printează
        </Button>
      </div>

      {/* Printable Content */}
      <div className="max-w-[210mm] mx-auto p-3 bg-white min-h-screen print:p-2 text-[8px]">
        {/* Header */}
        <div className="text-center mb-1 border-b-2 border-black pb-1">
          <h1 className="text-sm font-bold">🧲 TRANSFORMARE MAGNETICĂ - Fișa Prospect</h1>
        </div>

        {/* Client Info */}
        <div className="grid grid-cols-4 gap-1 mb-1 p-1 border border-gray-400">
          <div><span className="font-bold">NUME:</span><div className="border-b border-gray-400 h-4"></div></div>
          <div><span className="font-bold">TELEFON:</span><div className="border-b border-gray-400 h-4"></div></div>
          <div><span className="font-bold">DATA:</span><div className="border-b border-gray-400 h-4"></div></div>
          <div><span className="font-bold">ORA:</span><div className="border-b border-gray-400 h-4"></div></div>
        </div>

        {/* ==================== CALL 1 ==================== */}
        <div className="border-2 border-blue-500 rounded mb-1">
          <div className="bg-blue-500 text-white font-bold p-0.5 text-center text-[10px]">📞 APELUL 1 - CALIFICARE</div>
          
          {/* Deschidere */}
          <div className="p-1 bg-gray-50 border-b border-gray-300">
            <div className="font-bold">🎯 DESCHIDERE</div>
            <div className="italic">"Alo [NUME]? [EU] sunt... din echipa <b>Transformare Magnetică</b> cu <b>Răzvan Tiberiu Pop</b>. Te-ai înscris la webinarul cu Răzvan. <b>Ai reușit să-l vizionezi?</b>"</div>
            <div className="flex items-center gap-2 mt-1">
              <span className="font-bold">Vizionat?</span>
              <span>☐ Da → "Super!"</span>
              <span>☐ Nu → "Îți trimit înregistrarea la final"</span>
            </div>
          </div>

          {/* Disponibilitate */}
          <div className="p-1 bg-blue-50 border-b border-gray-300">
            <span className="italic">"<b>Ai două minute</b> să-ți dau câteva detalii?"</span>
            <span className="ml-2">☐ Da ☐ Nu → Reprogramare: ________</span>
          </div>

          {/* Cunoștințe manifestare */}
          <div className="p-1 bg-purple-50 border-b border-gray-300">
            <span className="italic">"<b>Ai ceva cunoștințe despre LEGEA ATRACȚIEI / MANIFESTARE?</b>"</span>
            <span className="ml-1">☐ Da ☐ Nu ☐ Puțin</span>
            <div className="border border-gray-300 h-5 mt-1 bg-white"></div>
          </div>

          {/* De cât timp */}
          <div className="p-1 border-b border-gray-300">
            <span className="italic">"<b>De cât timp îl știi pe Răzvan?</b>"</span>
            <div className="border border-gray-300 h-4 mt-1 bg-white"></div>
          </div>

          {/* S1 - Situația actuală */}
          <div className="p-1 bg-red-50 border-b border-red-300">
            <div className="font-bold text-red-700">📍 S1 - SITUAȚIA ACTUALĂ</div>
            <div className="italic">"Hai să vedem <b>cum te putem ajuta</b> și <b>ce e prioritar să îmbunătățești</b> în viața ta."</div>
            
            <div className="grid grid-cols-2 gap-1 mt-1">
              <div>
                <span className="italic">"<b>Cu ce te ocupi?</b>"</span>
                <div className="border border-gray-300 h-5 bg-white"></div>
              </div>
              <div>
                <span className="italic">"<b>Ești mulțumit/ă de job?</b>"</span>
                <span className="ml-1">☐ Da ☐ Nu ☐ Parțial</span>
                <div className="border border-gray-300 h-5 bg-white"></div>
              </div>
            </div>
          </div>

          {/* S2 - Obiective */}
          <div className="p-1 bg-green-50 border-b border-green-300">
            <div className="font-bold text-green-700">🎯 S2 - OBIECTIVE</div>
            <div className="italic">"<b>Imaginează-ți că ai un mentor</b>, ce obiective sunt prioritare? <b>Financiar, relații, sănătate, profesional?</b>"</div>
            <div className="flex gap-2 mt-1">
              <span>☐ 💰 Financiar</span>
              <span>☐ ❤️ Relații</span>
              <span>☐ 🏃 Sănătate</span>
              <span>☐ 💼 Profesional</span>
            </div>
            
            <div className="mt-1 p-1 bg-yellow-50 border-l-2 border-yellow-500">
              <span className="font-bold">Dacă FINANCIAR:</span>
              <div className="italic">"<b>Cât ți-ai dori să câștigi lunar</b> ca să fii mulțumit?"</div>
              <div className="border border-gray-300 h-4 bg-white"></div>
              <div className="italic mt-1">"<b>La ce sumă ești acum?</b>"</div>
              <div className="border border-gray-300 h-4 bg-white"></div>
            </div>
          </div>

          {/* Blocaje */}
          <div className="p-1 bg-orange-50 border-b border-orange-300">
            <div className="font-bold text-orange-700">🚧 BLOCAJE</div>
            <div className="italic">"<b>Ce crezi că te-a blocat până acum să-ți atingi obiectivele?</b>"</div>
            <div className="border border-gray-300 h-10 mt-1 bg-white"></div>
          </div>

          {/* Prezentare program */}
          <div className="p-1 bg-purple-50 border-b border-purple-300">
            <div className="font-bold text-purple-700">💡 PREZENTARE PROGRAM</div>
            <div className="italic text-[7px]">"E un program cu <b>Răzvan ca mentor 1 la 1</b>, primești pe WhatsApp <b>tehnici de manifestare</b>. Trebuie făcute <b>cu pixul și foaia</b> pentru conexiuni neuronale noi și eliminarea blocajelor. După eliminăm blocajele, ne ridicăm vibrația și <b>atragem oamenii potriviți</b>. E nevoie de <b>30 min/zi</b>, programul durează <b>3-6 luni</b>."</div>
            <div className="italic mt-1">"<b>Ai întrebări?</b>"</div>
            <div className="border border-gray-300 h-6 bg-white"></div>
          </div>

          {/* Încheiere Apel 1 */}
          <div className="p-1 bg-cyan-50">
            <div className="font-bold text-cyan-700">👋 ÎNCHEIERE APEL 1</div>
            <div className="italic">"Ok, <b>îți las materiale pe WhatsApp</b> și <b>revin peste 2 zile</b>. <b>La ce oră să revin?</b>"</div>
            <div className="flex items-center gap-2 mt-1">
              <span className="font-bold">Callback:</span>
              <div className="border-b border-gray-400 flex-1"></div>
              <span className="font-bold">Salvat nr?</span>
              <span>☐ Da ☐ Nu</span>
            </div>
          </div>
        </div>

        {/* ==================== CALL 2 ==================== */}
        <div className="border-2 border-green-500 rounded mb-1">
          <div className="bg-green-500 text-white font-bold p-0.5 text-center text-[10px]">📞 APELUL 2 - FOLLOW-UP & PROGRAMARE ZOOM</div>
          
          {/* Reconectare */}
          <div className="p-1 bg-green-50 border-b border-green-300">
            <div className="font-bold">🔄 RECONECTARE</div>
            <div className="italic">"Alo [NUME]? [EU] sunt... am revenit cum am stabilit. <b>Ai vizionat materialele? Cum ți s-au părut?</b>"</div>
            <div className="flex items-center gap-2">
              <span>Vizionat? ☐ Da ☐ Nu</span>
              <span className="font-bold">Feedback:</span>
              <div className="border-b border-gray-400 flex-1"></div>
            </div>
            <div className="italic mt-1">"<b>Ai întrebări?</b>"</div>
            <div className="border border-gray-300 h-5 bg-white"></div>
          </div>

          {/* Investiție */}
          <div className="p-1 bg-amber-50 border-b border-amber-300">
            <div className="font-bold text-amber-700">💰 INVESTIȚIE</div>
            <div className="italic">"Este un <b>program premium</b> care are un cost. <b>Ești dispus/ă să investești în tine</b> pentru a-ți atinge obiectivele?"</div>
            <span>☐ Da ☐ Nu ☐ Depinde</span>
          </div>

          {/* Programare Zoom */}
          <div className="p-1 bg-blue-50 border-b border-blue-300">
            <div className="font-bold text-blue-700">📅 PROGRAMARE ZOOM</div>
            <div className="italic">"Următorul pas: <b>programare pe Zoom</b> cu un coleg expert. Primești o <b>ofertă de preț valabilă o singură dată</b>. E nevoie să ai <b>câteva sute de euro disponibili</b> pentru plată în cadrul întâlnirii."</div>
            <div className="italic mt-1">"<b>Ai acești bani disponibili pentru reducerea de preț?</b>"</div>
            <span>☐ Da ☐ Nu</span>
          </div>

          {/* Opțiuni de plată - dacă nu are avans */}
          <div className="p-1 bg-yellow-50 border-b border-yellow-300">
            <div className="font-bold text-yellow-700">💳 DACĂ NU ARE AVANS - OPȚIUNI DE PLATĂ</div>
            <div className="italic text-[7px]">"Găsim soluții! <b>Plan de plăți</b> cu colegul meu, sau colaborare cu <b>TBI</b> (12-60 luni, de la 80€/lună)."</div>
            <div className="mt-1 p-1 bg-slate-100 text-[7px]">
              <span className="font-bold">Eligibilitate TBI:</span> Angajat perioadă nedeterminată | Min 3 salarii | Fără istoric negativ | Rate max 40% din venit
            </div>
            <span>Eligibil TBI? ☐ Da ☐ Nu ☐ Nu știu</span>
          </div>

          {/* Calificare & Programare */}
          <div className="p-1 bg-green-100 border-b border-green-300">
            <div className="font-bold text-green-700">✅ CALIFICARE & PROGRAMARE</div>
            <div className="italic">"Din ce văd, <b>te califici și ai potențial să faci lucruri mari</b>. <b>Hai să facem o programare?</b>"</div>
            <div className="flex items-center gap-2 mt-1">
              <span className="font-bold">Data Zoom:</span>
              <div className="border-b border-gray-400 w-24"></div>
              <span className="font-bold">Ora:</span>
              <div className="border-b border-gray-400 w-16"></div>
            </div>
          </div>

          {/* Încheiere */}
          <div className="p-1 bg-purple-50">
            <div className="font-bold text-purple-700">👋 ÎNCHEIERE APEL 2</div>
            <div className="italic">"Rămâne în ziua de <b>[DATA]</b> la <b>[ORA]</b>. Primiți link-ul de Zoom de la expert. <b>La revedere, zi frumoasă!</b>"</div>
          </div>
        </div>

        {/* Note */}
        <div className="p-1 border border-gray-400">
          <span className="font-bold">📝 NOTE:</span>
          <div className="border border-gray-300 h-12 bg-white"></div>
        </div>

        {/* Footer */}
        <div className="text-center text-gray-400 text-[7px] mt-1">
          Transformare Magnetică | financiallyfree.ro
        </div>
      </div>

      {/* Print Styles */}
      <style>{`
        @media print {
          @page {
            margin: 3mm;
            size: A4;
          }
          body {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        }
      `}</style>
    </>
  );
};

export default FisaClient;
